<template>
  <div>
    
    <!-- Первый экран страницы -->
    <main-header start-price-purchase="600" name="СТЕК" name-int="stack" />

    <!-- Плюсы использования сервиса -->
    <main-postheader></main-postheader>

    <!-- Кому подойдёт сервис -->
    <main-subjects></main-subjects>

    <!-- Положения 54-ФЗ важные для ЖКХ -->
    <main54fz></main54fz>

    <change-page :rent='false' int="stack" purchase-link="/gkh/stack/purchase#change-page" rent-link="/gkh/stack#change-page"/>

    <!-- Секция с калькулятором -->
    <calc-section start-price-rent="1800" start-price-purchase="600" subscribtion="true"></calc-section>

    <free-test />

    <!-- Почему мы? -->
    <why-we></why-we>

    <how-to-connect />

    <!-- Способы формирования чека -->
    <main-ways-form-check :int='true'></main-ways-form-check>

     <!-- Таблица с санкциями -->
    <fines-table></fines-table>

    <!-- Секция о штрафах -->
    <main-fines></main-fines>

    <!-- Вопросы и ответы -->
    <questions-section></questions-section>

    <cta />

    <modal></modal>

    <modal-feedback />
    <modal-support />

  </div>
</template>

 

<script>
import mainHead from '~/components/header'
import mainHeader from '~/components/purchase/purchase-header'
import mainPostheader from '~/components/purchase/purchase-first'
import mainSubjects from '~/components/purchase/purchase-second'
import main54fz from '~/components/purchase/54-fz'
import mainFines from '~/components/purchase/purchase-fifth'
import finesTable from '~/components/sanction-section'
import CalcSection from "~/components/purchase/calc-section";
import whyWe from '~/components/purchase/why-we'
import mainWaysFormCheck from '~/components/purchase/purchase-sixth'
import mainConnectionMethods from '~/components/purchase/purchase-seventh'
import questionsSection from '~/components/purchase/questions-section'
import mainFooter from '~/components/footer'
import modal from '~/components/modal'
import modalFeedback from '~/components/modal-feedback'
import modalSupport from '~/components/modal-support'
import changePage from '@/components/change-page'
import freeTest from '@/components/free-test'
import howToConnect from '@/components/how-to-connect'
import cta from '@/components/call-to-action'


export default {
  head: {
    title: 'Онлайн-касса для ЖКХ - интеграция со СТЕК',
    meta: [
      {hid: 'description', name: 'description', content: 'Онлайн-касса для УК и РСО - интеграция с платежной системой СТЕК. Кому подойдет сервис. Стоимость. Выберите удобный вариант и подключитесь прямо сейчас!'}
    ]
  },
  components: {
    mainHead,
    mainHeader,
    mainPostheader,
    mainSubjects,
    main54fz,
    mainFines,
    finesTable,
    CalcSection,
    whyWe,
    mainWaysFormCheck,
    mainConnectionMethods,
    questionsSection,
    mainFooter,
    modal,
    modalFeedback,
    modalSupport,
    changePage,
    freeTest,
    howToConnect,
    cta
  },
  created: function() {
    let terms = [
      {
        period: 3,
        price: 2250,
        mouth: "месяца"
      },
      {
        period: 6,
        price: 4140,
        mouth: "месяцев"
      },
      {
        period: 12,
        price: 7200,
        mouth: "месяцев"
      }
    ]
    this.$store.dispatch('calc/set_terms', terms);
  }
}
</script>

<style lang="sass">

</style>
